var _rect, _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPicto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    rx: 96,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.8101 183.221C72.7136 183.009 50.6352 173.686 34.378 157.278C18.1207 140.871 9 118.708 9 95.6107C9 72.5132 18.1207 50.3501 34.378 33.943C50.6352 17.5358 72.7136 8.21203 95.8101 8C111.189 8.01922 126.294 12.075 139.614 19.7619C152.934 27.4488 164.003 38.4975 171.715 51.8035C172.927 53.9031 173.713 56.2208 174.03 58.6243C174.346 61.0278 174.186 63.4701 173.558 65.8117C172.93 68.1533 171.848 70.3484 170.372 72.2715C168.896 74.1947 167.055 75.8083 164.956 77.0202C160.716 79.4678 155.677 80.1308 150.948 78.8632C146.219 77.5956 142.187 74.5013 139.739 70.2611C135.281 62.5627 128.88 56.1695 121.176 51.7204C113.472 47.2712 104.736 44.9221 95.8396 44.9078C82.5003 45.0687 69.7619 50.4807 60.386 59.9705C51.0101 69.4602 45.7522 82.263 45.7522 95.6033C45.7522 108.944 51.0101 121.746 60.386 131.236C69.7619 140.726 82.5003 146.138 95.8396 146.299C104.735 146.284 113.47 143.935 121.174 139.487C128.877 135.04 135.279 128.649 139.739 120.953C142.187 116.713 146.219 113.618 150.948 112.351C155.677 111.083 160.716 111.746 164.956 114.194C169.196 116.641 172.29 120.673 173.558 125.402C174.826 130.131 174.163 135.17 171.715 139.41C164.004 152.718 152.936 163.768 139.615 171.456C126.295 179.144 111.19 183.201 95.8101 183.221V183.221Z",
    fill: "#007BC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.193 61.0767H80.1729V130.137H112.193V61.0767Z",
    fill: "#DEDC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.429 111.621V79.6011H61.3679V111.621H130.429Z",
    fill: "#DEDC00"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M112.193 69.6714H80.1729V79.6016H112.193V69.6714Z",
    fill: "url(#paint0_linear_1607_7148)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M80.1727 121.551H112.193V111.621H80.1727V121.551Z",
    fill: "url(#paint1_linear_1607_7148)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1607_7148",
    x1: 96.1866,
    y1: 79.6016,
    x2: 96.1866,
    y2: 69.6714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFDEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1607_7148",
    x1: 96.1791,
    y1: 111.621,
    x2: 96.1791,
    y2: 121.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFDEC"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicto);
export default __webpack_public_path__ + "static/media/picto.59ef7d66e100c4751d1cacd1a37153e8.svg";
export { ForwardRef as ReactComponent };